import React, { useEffect, useState } from "react";
import MobileNav from "../../Global/mobileNav";
import Head from "../../Global/Head";
import Header from "../../Global/Header";
import { sendNotification } from "../../../services/notification";
import NotificationCards from "../../shared/navNotificationIcon/notificationCards/NotificationCards";
import { Link, useNavigate } from "react-router-dom";

const Notification = () => {
  const accessToken = localStorage.getItem("@user");
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]); // State to store notifications

  const getNoti = async () => {
    try {
      const res = await sendNotification(); // Fetch notifications
      setNotifications(res.items); // Set the notifications array
    } catch (error) {
      console.error("Failed to fetch notifications", error);
    }
  };

  useEffect(() => {
    if (accessToken) {
      getNoti();
    }
  }, [accessToken]);

  useEffect(() => {
    // Check screen width
    if (window.innerWidth > 768) {
      // Redirect to "/" if on desktop
      navigate("/");
    }
  }, [navigate]);

  return (
    <>
      <div className="z-[100]">
        <Link to={"/mobileSearch"} className="sm:hidden stickynav-custom">
          <div style={{ pointerEvents: "none" }}>
            <Head />
            <Header setIsVisible={false} />
          </div>
        </Link>
      </div>
      <nav className="justify-start items-start h-screen">
        {notifications.length > 0 ? (
          notifications.map((notification, index) => (
            <NotificationCards key={index} notification={notification} />
          ))
        ) : (
          <p className="h-32 text-center pt-10 justify-center text-center text-stone-400 items-center">
            Nothing brewing yet!
          </p>
        )}
      </nav>
      <MobileNav />
    </>
  );
};

export default Notification;
